import Lookup from 'src/componentes/select2';

const TipoLimite = (props) => (
  <Lookup
    labelKey="descricao"
    valueKey="id"
    url="/TipoLimiteLookup"
    {...props}
  />
);

export default TipoLimite;
